import * as bootstrap from "bootstrap";
import { Chart } from "chart.js/auto";

window.bootstrap = bootstrap;
window.Chart = Chart;

/**
 * fetch() wrapper that attaches the page's CSRF token header, since every
 * state-changing request in the app goes through the global CSRF filter.
 */
window.bimetaFetch = function (url, options = {}) {
    const tokenMeta = document.querySelector('meta[name="csrf-token"]');
    const headerMeta = document.querySelector('meta[name="csrf-header"]');

    const headers = Object.assign({}, options.headers || {});

    if (tokenMeta && headerMeta) {
        headers[headerMeta.content] = tokenMeta.content;
    }

    if (options.json !== undefined) {
        headers["Content-Type"] = "application/json";
        options.body = JSON.stringify(options.json);
        delete options.json;
    }

    return fetch(url, Object.assign({}, options, { headers }));
};
